<template>
  <el-col>
    <el-card class="data">
      <div class="data-title" slot="header">
        <img class="report-img" src="@/assets/images/videos.svg" alt="" />
        <span>TOP VIDEOS</span>
        <router-link class="overview-action" to="/artist/my-videos"
          >OVERVIEW<i class="el-icon-arrow-right"></i
        ></router-link>
      </div>
      <div
        class="tableCommands"
        :class="window.width < '710' ? 'flex-end' : 'd-none'"
      >
        <p
          class="ml10"
          v-for="(item, index) in columns"
          :key="index"
          @click="handleCommand(item)"
          :class="{ active: columnShown === item.name }"
        >
          {{ item.name }}
        </p>
      </div>
      <el-table
        :data="video"
        class="w100 dashboard-table"
        v-loading="loading_video"
      >
        <el-table-column label="Title" prop="title">
          <template slot-scope="props">
            <a
              :href="`https://youtube.com/watch?v=${props.row.video_id}`"
              target="_blank"
            >
              {{ props.row.title }}
            </a>
          </template>
        </el-table-column>
        <el-table-column
          label="Subscribers"
          prop="subscribers"
          align="right"
          v-if="columnShown === 'Subscribers' || window.width > '710'"
          :formatter="commaNumTable"
          sortable
        >
        </el-table-column>
        <el-table-column
          label="Views"
          prop="views"
          align="right"
          v-if="columnShown === 'Views' || window.width > '710'"
          :formatter="commaNumTable"
          sortable
        ></el-table-column>
        <el-table-column
          label="Budget spent"
          prop="budget_spent"
          align="right"
          v-if="columnShown === 'Budget spent' || window.width > '710'"
          sortable
        >
          <template v-slot="props">
            <p v-if="props.row.video_approved == 1 && props.row.budget_spent > 0">${{ props.row.budget_spent }}</p>
            <p v-else>Free</p>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </el-col>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  computed: {
    ...mapState('artistDashboard', ['PieChartSett']),
    ...mapState('artistDashboard', [
      'loading_video',
      'video',
      'artist_track',
      'artist_label'
    ])
  },

  data() {
    return {
      columnShown: 'Subscribers',
      columns: [
        {
          name: 'Subscribers',
          command: 'subscribers'
        },
        {
          name: 'Views',
          command: 'views'
        },
        {
          name: 'Budget spent',
          command: 'budget'
        }
      ]
    }
  },

  watch: {
    artist_track: function(valN, valO) {
      if (valN !== null) {
        this.readTopVideo()
      }
    },
    artist_label: function(valN, valO) {
      if (valN !== null) {
        this.readTopVideo()
      }
    }
  },

  methods: {
    ...mapActions('artistDashboard', ['readTopVideo']),

    handleCommand(column) {
      this.columnShown = column.name
      this.readTopVideo(column.command)
    }
  },

  created() {
    this.readTopVideo()
    window.addEventListener('resize', this.windowWidth)
    this.windowWidth()
  },

  destroyed() {
    window.removeEventListener('resize', this.windowWidth)
  }
}
</script>
